import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import Config from "../../Config";
import { l } from "../../libs/localization";
import {
  getGMapsFormattedAddress,
  getGmapStringAddress,
} from "../../libs/utils";
import { reverseGeoCoding } from "../../api/common.api";

const APIKEY = Config.googleApiKey;

const AddressItem = ({ addressData, vertical, apiKey }) => {
  const [results, setResults] = useState([]);
  const mountedRef = React.useRef(true);

  const getReverseGeocoding = async (addr) => {
    const address = encodeURI(getGmapStringAddress(addr));
    try {
      const geo = await reverseGeoCoding(address);
      return geo;
    } catch (e) {
      console.error(e);
      return {};
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    if (!addressData.position || !addressData.position.lat) {
      getReverseGeocoding(addressData).then((res) => {
        if (!mountedRef.current) return;
        setResults(res.results || []);
      });
    }
    return () => {
      mountedRef.current = false;
    };
  }, [addressData]);

  let lat = addressData.position?.lat;
  let lng = addressData.position?.lng;

  if ((!lat || !lng) && results && results.length > 0) {
    const firstResult = results[0];
    if (firstResult && firstResult.geometry && firstResult.geometry.location) {
      lat = firstResult.geometry.location.lat;
      lng = firstResult.geometry.location.lng;
    }
  }

  const centerStr = addressData.address
    ? `${addressData.address}+${addressData.city || ""}`
    : addressData.company?.address
    ? `${addressData.company.address}+${addressData.company.city || ""}`
    : "";

  const markersParam = lat && lng ? `&markers=color:red%7C${lat},${lng}` : "";
  const mapSrc = `https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(centerStr)}&zoom=16&size=250x250${markersParam}&key=${apiKey}`;

  return (
    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
      <Col span={vertical ? 24 : 12}>
        {getGMapsFormattedAddress(addressData)}
        {addressData.addressNotes && (
          <div style={{ marginTop: 8 }}>
            <b>{l("COMMON.ADDRESS_NOTE")}:</b>
            <p style={{ margin: 0 }}>{addressData.addressNotes}</p>
          </div>
        )}
      </Col>
      <Col span={vertical ? 24 : 10} style={{ marginTop: vertical ? 12 : 0, textAlign: vertical ? "left" : "right" }}>
        <a
          href={`https://www.google.it/maps?q=${encodeURI(
            getGmapStringAddress(addressData)
          )}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={mapSrc}
            alt="Google Maps Static Preview"
            style={{ width: 200, height: 200, objectFit: "cover", borderRadius: 8, border: "1px solid #e8e8e8" }}
          />
        </a>
      </Col>
    </Row>
  );
};

const CardAddress = (props) => {
  const { data, vertical = true } = props;
  const addresses = data.addresses || data.company?.addresses;

  return (
    <Card
      title={
        <h2>
          <b>{l("PAGES.CONTACTS.DETAIL.SECTIONS.GENERAL.ADDRESS")}</b>
        </h2>
      }
      bordered={false}
      className="companyPage__body-card companyPage__body-card--custom"
    >
      {addresses && addresses.length > 0 ? (
        addresses.map((addr, idx) => (
          <div key={addr._id || idx}>
            {idx > 0 && <hr style={{ border: 0, borderTop: "1px solid #f0f0f0", margin: "24px 0" }} />}
            <AddressItem addressData={addr} vertical={vertical} apiKey={APIKEY} />
          </div>
        ))
      ) : (
        <AddressItem addressData={data} vertical={vertical} apiKey={APIKEY} />
      )}
    </Card>
  );
};

export default CardAddress;
